// extracted by mini-css-extract-plugin
export var btn = "K_mB y_tg y_s0 d_bz d_bP d_bD d_dw";
export var full = "K_vv d_w d_H";
export var hoverStyle = "K_mF";
export var zoom = "K_mG";